import React, { useEffect, useState } from 'react'

import { func, string } from 'prop-types'

let AiSignInModal = null
let aiSignInModalImportPromise = null

export const importAiSignInModal = () => {
  if (!aiSignInModalImportPromise) {
    aiSignInModalImportPromise = import(
      /* webpackChunkName: "ai-sign-in-modal" */
      './AiSignInModal'
    ).then((mod) => { AiSignInModal = mod.default })
  }
  return aiSignInModalImportPromise
}

function LazyAiSignInModal({ mode, step = undefined, onClose }) {
  const [isLoaded, setIsLoaded] = useState(() => !!AiSignInModal)

  useEffect(() => {
    if (!AiSignInModal) {
      importAiSignInModal().then(() => setIsLoaded(true))
    }
  }, [])

  if (!isLoaded || !AiSignInModal) return null
  return <AiSignInModal mode={mode} initialStep={step} onClose={onClose} />
}

LazyAiSignInModal.propTypes = {
  mode: string.isRequired,
  step: string,
  onClose: func.isRequired,
}

export default LazyAiSignInModal
